import { Currency, Locale } from '@synergy/models';
import { getLocalizedString } from '@synergy/utils';

import { ArticleVariant } from '../article-variant';
import { ArticleVariantDto } from '../dto/article-variant-dto';

export const mapArticleVariant = (
    locales: Locale[],
    currency: Currency,
    variant: ArticleVariantDto
): ArticleVariant => ({
    id: variant.id,
    currentPrice: variant.currentPrice[currency] ?? 0,
    isActive: variant.isActive,
    name: getLocalizedString(locales, variant.name),
    number: variant.number,
    attributes: variant.attributes,
    previewImage: variant.previewImage,
    updatedAt: variant.updatedAt && new Date(variant.updatedAt),
});
